var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedInIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Page-1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.424,
    height: 22.424,
    viewBox: "0 0 22.424 22.424",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social-Icons---Rounded"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Linkedin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rounded",
    d: "M2.492,22.424H19.933a2.492,2.492,0,0,0,2.492-2.492V2.492A2.492,2.492,0,0,0,19.933,0H2.492A2.492,2.492,0,0,0,0,2.492V19.933A2.492,2.492,0,0,0,2.492,22.424Z",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_850",
    "data-name": "Tracciato 850",
    d: "M26.2,26.2H22.868V20.528c0-1.554-.59-2.422-1.82-2.422-1.338,0-2.037.9-2.037,2.422V26.2H15.8V15.4H19.01v1.454a3.767,3.767,0,0,1,3.255-1.784c2.29,0,3.93,1.4,3.93,4.291ZM11.977,13.985a1.992,1.992,0,1,1,1.977-1.992A1.985,1.985,0,0,1,11.977,13.985ZM10.322,26.2h3.344V15.4H10.322Z",
    transform: "translate(-6.886 -6.886)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInIcon);
export default __webpack_public_path__ + "static/media/LinkedIn_Icon.c23a5a15f6d049cb31fb48a3c17bd24a.svg";
export { ForwardRef as ReactComponent };